import { c as _c } from "react/compiler-runtime";
import { useIntl } from "react-intl";
import FormItem from "forms/fields/FormItem";
import type { FieldProps } from "forms/fields/Languages/types";
import parseDictionary from "forms/helpers/parseDictionary";
import { predefinedFields } from "types/predefinedFields";
import { Select } from "ui/Select/Select";
import { FormField } from "uiShadcn/form";
import { sortObjectValuesAsArray } from "utils/helpers/sortObjectValuesAsArray";
export default function LanguagesField(t0) {
  const $ = _c(12);
  const {
    control,
    index,
    isRequired,
    enumValues,
    enumNames
  } = t0;
  const {
    formatMessage
  } = useIntl();
  const name = `${predefinedFields.languages}.${index}.language`;
  let t1;
  if ($[0] !== enumNames || $[1] !== enumValues) {
    const languages = parseDictionary({
      enumNames,
      enumValues
    });
    t1 = sortObjectValuesAsArray(languages);
    $[0] = enumNames;
    $[1] = enumValues;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const langSorted = t1;
  let t2;
  if ($[3] !== formatMessage || $[4] !== index || $[5] !== isRequired || $[6] !== langSorted) {
    t2 = t3 => {
      const {
        field
      } = t3;
      return <FormItem label={formatMessage({
        id: "chooseLanguage"
      })} required={isRequired}><Select ref={field.ref} dataTestId={`Select-[${index}].language`} defaultValue={field.value} onValueChange={field.onChange} required={isRequired} options={langSorted} placeholder={formatMessage({
          id: "select"
        })} /></FormItem>;
    };
    $[3] = formatMessage;
    $[4] = index;
    $[5] = isRequired;
    $[6] = langSorted;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== control || $[9] !== name || $[10] !== t2) {
    t3 = <FormField control={control} name={name} render={t2} />;
    $[8] = control;
    $[9] = name;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}